import React from 'react';
import useStyles from './VersionsTable.styles';

interface VersionsTableProps {
  gaVersion?: string;
  canaryVersion?: string;
}

export const VersionsTable: React.FC<VersionsTableProps> = ({
  gaVersion,
  canaryVersion,
}) => {
  const classes = useStyles();

  return (
    <div>
      {gaVersion && (
        <table className={classes.versions}>
          <th>Version</th>
          <tr>
            <td>{gaVersion} (GA)</td>
          </tr>
          {canaryVersion && (
            <tr>
              <td>{canaryVersion} (Canary)</td>
            </tr>
          )}
        </table>
      )}
    </div>
  );
};
